package com.milta.core.localization.translations.en

import com.milta.core.localization.WebImportRouteStrings

internal val WebImportRoute = WebImportRouteStrings(
    headerSubtitle = "Upload a delivery file and assign it to a driver",
    stepImport = "Import",
    stepVerifyAssign = "Verify & assign",
    stepValidateSend = "Validate and send the routes",
    dropzoneTitle = "Drag and drop your delivery file",
    dropzoneOrPrefix = "or",
    browseFilesLink = "browse your files",
    browseFilesButton = "Browse files",
    constraintsLabel = "Excel (.xlsx, .xls), CSV or PDF · 500 stops max · 10 MB",
    expectedColumnsEyebrow = "Expected columns in the file",
    columnRecipientName = "Recipient name",
    columnAddress = "Full address",
    columnDeadline = "Deadline",
    columnPhone = "Phone",
    requiredPillLabel = "Required",
    optionalPillLabel = "Optional",
    analysingLabel = "Analysing…",
    analysingCanLeaveLabel = "File sent. You can leave this page, the analysis continues.",
    importOnMobileMessage = "An import is in progress in the mobile app (%s). Finish it in the app to import another file here.",
    invalidFileTitle = "Unreadable file or unsupported format",
    invalidFileMessage = "\"%s\" could not be analysed. Use an Excel (.xlsx, .xls), CSV or PDF file matching the expected columns.",
    chooseAnotherFileButton = "Choose another file",
    extractionFailedTitle = "Unable to extract deliveries",
    extractionFailedMessage = "The file \"%s\" was read but no usable row was found. Check that it contains the expected columns.",
    serviceUnavailableTitle = "Analysis service temporarily unavailable",
    serviceUnavailableMessage = "We can't analyse your file right now. Your file is kept: try again in a moment.",
    retryButton = "Retry",
    fileImportedStatus = "File imported",
    stopsDetectedSuffix = "stops detected",
    replaceFileLink = "↺ Replace",
    assignToEyebrow = "Assign to",
    selectDriverRequiredError = "Please select at least one driver before sending the route.",
    selectedDriversCountSuffix = "drivers selected",
    optimizeRouteButton = "Optimize the route",
    tableCaptionLead = "Check and correct the stops before sending",
    tableCaptionHint = "Click the pencil icon to correct a row",
    locationBlockedHint = "Every row needs a located address (GPS) before sending to the drivers. Edit the affected rows (✎) or retry geocoding.",
    columnHeaderIndex = "#",
    columnHeaderRecipientName = "Recipient name",
    columnHeaderAddress = "Address",
    columnHeaderPhone = "Phone",
    columnHeaderDeadline = "Deadline",
    columnHeaderPackageCount = "Packages",
    dashPlaceholder = "—",
    discardDraftButton = "Discard import",
    discardDraftDialogTitle = "Discard this import?",
    discardDraftDialogMessage = "The deliveries already imported will be permanently lost. This action cannot be undone.",
    discardDraftConfirmButton = "Yes, discard import",
    freeFormatBanner = "Free format detected — columns could not be automatically recognized, check every row before sending.",
    incompleteStopsBannerSuffix = "incomplete stops — missing name or address, to correct before sending.",
    rowFlagMissingName = "⚠ missing name",
    rowFlagMissingAddress = "⚠ missing address",
    alreadyDispatchedBanner = "This route has already been sent to a driver — refresh the page to start a new import.",
    routeNotFoundError = "Route not found. Refresh the page and try again.",
    validationErrorGeneric = "Please check the information entered.",
    submitServerError = "An error occurred. Please try again.",
    submitOptimizationUnavailableError = "Optimization service temporarily unavailable. The route was not created — try again in a moment.",
    sendWithoutOptimizationButton = "Send without optimization",
    dispatchSuccessMessage = "Route successfully sent to %s",
    dispatchSuccessBatchMessage = "Routes successfully sent to %d drivers",
    tooManyStopsError = "This file contains more than 500 deliveries. Please split it before importing.",
    resultHeaderMiddle = "deliveries split between",
    resultDriverSingularSuffix = "driver",
    resultDriverPluralSuffix = "drivers",
    resultDistanceLabel = "Distance",
    resultDurationLabel = "Estimated duration",
    resultMetricNotCalculatedLabel = "Not calculated",
    resultStopsChipSuffix = "stops",
    resultMoreStopsTemplate = "+ %d more stops",
    resultStopsLoadError = "Couldn't load this route's stops.",
    resultDispatchButton = "Validate and send the routes",
)
